import { post } from '@/api'
import { getItem, setItem } from '@/utils/localStorageWithExpiration'

function generateAndSetNewClientToken(key) {
  const token = Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(0, 8)
  setItem(key, token)

  return token
}

export default {
  namespaced: true,
  state: {
    name: getItem('user/name'),
    client_token: getItem('user/client-token') || generateAndSetNewClientToken('user/client-token'),
    name_prompt_rejected: getItem('user/name-prompt-rejected')
  },
  mutations: {
    REMEMBER_NAME(state, { name }) {
      state.name = name
      setItem('user/name', name)
    },

    SET_NAME_PROMPT_REJECTED(state, rejected) {
      state.name_prompt_rejected = rejected
      // Don't ask for 1 day
      setItem('user/name-prompt-rejected', rejected, 24)
    }
  },
  actions: {
    REMEMBER_NAME({ commit }, { name }) {
      commit('REMEMBER_NAME', { name })
    },

    SET_NAME_PROMPT_REJECTED({ commit }, rejected) {
      commit('SET_NAME_PROMPT_REJECTED', rejected)
    },

    async CREATE_NEWSLETTER_SIGNUP(_, email) {
      const body = JSON.stringify({
        email,
        name: 'noname',
        phone: 'nophone'
      })

      try {
        await post('newsletter-subscriptions', {
          body,
          headers: { accept: 'text/html' }
        })
        return true
      } catch (error) {
        throw error
      }
    }
  }
}
